import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { UNAUTHENTICATED_ENTRY, REDIRECT_URL_KEY } from "configs/AppConfig";
import { authStore } from "stores/auth.store";

const ProtectedRoute = () => {
  const token = authStore.getState().token;

  const location = useLocation();

  if (!token) {
    return (
      <Navigate
        to={`${UNAUTHENTICATED_ENTRY}?${REDIRECT_URL_KEY}=${location.pathname}`}
        replace
      />
    );
  }

  return <Outlet />;
};

export default ProtectedRoute;
